import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'matchTime'})
export class MatchTimePipe implements PipeTransform {
  transform(value: number, args: string[]): any {
    if (value === undefined || value === null) { return value; }
    const minutes = Math.floor(value / 60);
    const seconds = Math.floor(value % 60);
    return `${minutes < 10 ? '0' + minutes : minutes}<span>:</span>${ seconds < 10 ? '0' + seconds : seconds}`;
  }
}
